module.exports = __webpack_public_path__ + "img/demi-human.2497c571.jpg";